/* eslint-disable no-console, camelcase, quotes */
const AREA_NAGOYA = '名古屋市'
const AREA_OUTSIDE_NAGOYA_CITY = '名古屋市外'
const AREA_GIFU = '岐阜'
const AREA_MIE = '三重'

const GENRE_ITALIAN = 'イタリアン'
const GENRE_FRENCH = 'フレンチ'
const GENRE_IZAKAYA = '居酒屋'
const GENRE_CAFE = 'カフェ'
const GENRE_JAPANESE = '和食'
const GENRE_WESTERN = '洋食'
const GENRE_BAKERY = 'ベーカリー'
const GENRE_SUSHI = '寿司'
const GENRE_CHINESE = '中華'
const GENRE_HOTEL = 'ホテル・旅館'
const GENRE_BRIDAL = 'ブライダル'
const GENRE_MASS_CATERING = '集団調理'
const GENRE_OTHER = 'その他'

const POSITION_KITCHEN_STAFF = 'キッチンスタッフ'
const POSITION_PATISSIER = 'パティシエ'
const POSITION_SUPERVISOR = 'スーパーバイザー'

const FILTER_POSITION_SERVICE_STAFF = 'サービススタッフ'
const FILTER_POSITION_HEAD_CHEF = '料理長'
const FILTER_POSITION_MANAGER = '店長'
const FILTER_POSITION_BOULANGER = 'ブーランジェ'

export const nagoyaConfig = {
    jobs: [],

    filters: {
        area: [AREA_NAGOYA, AREA_OUTSIDE_NAGOYA_CITY, AREA_GIFU, AREA_MIE],
        genre: [GENRE_ITALIAN, GENRE_FRENCH, GENRE_IZAKAYA, GENRE_CAFE, GENRE_JAPANESE, GENRE_WESTERN, GENRE_BAKERY, GENRE_SUSHI, GENRE_CHINESE, GENRE_HOTEL, GENRE_OTHER],
        position: [POSITION_KITCHEN_STAFF, FILTER_POSITION_SERVICE_STAFF, FILTER_POSITION_HEAD_CHEF, FILTER_POSITION_MANAGER, POSITION_PATISSIER, FILTER_POSITION_BOULANGER, POSITION_SUPERVISOR],
    },

    filtersList: {
        area: [
            {areaName: AREA_NAGOYA, dataClickLabel: 'CT_Jobinformation_名古屋'},
            {areaName: AREA_OUTSIDE_NAGOYA_CITY, dataClickLabel: 'CT_Jobinformation_エリア-名古屋市外'},
            {areaName: AREA_GIFU, dataClickLabel: 'CT_Jobinformation_エリア-岐阜'},
            {areaName: AREA_MIE, dataClickLabel: 'CT_Jobinformation_エリア-三重'},
        ],
        genre: [
            {genreName: GENRE_ITALIAN, dataClickLabel: 'CT_Jobinformation_料理ジャンル-イタリアン'},
            {genreName: GENRE_FRENCH, dataClickLabel: 'CT_Jobinformation_料理ジャンル-フレンチ'},
            {genreName: GENRE_IZAKAYA, dataClickLabel: 'CT_Jobinformation_料理ジャンル-居酒屋'},
            {genreName: GENRE_CAFE, dataClickLabel: 'CT_Jobinformation_料理ジャンル-カフェ'},
            {genreName: GENRE_JAPANESE, dataClickLabel: 'CT_Jobinformation_料理ジャンル-和食'},
            {genreName: GENRE_WESTERN, dataClickLabel: 'CT_Jobinformation_料理ジャンル-洋食'},
            {genreName: GENRE_BAKERY, dataClickLabel: 'CT_Jobinformation_料理ジャンル-ベーカリー'},
            {genreName: GENRE_SUSHI, dataClickLabel: 'CT_Jobinformation_料理ジャンル-寿司'},
            {genreName: GENRE_CHINESE, dataClickLabel: 'CT_Jobinformation_料理ジャンル-中華'},
            {genreName: GENRE_HOTEL, dataClickLabel: 'CT_Jobinformation_料理ジャンル-ホテル旅館'},
            {genreName: GENRE_OTHER, dataClickLabel: 'CT_Jobinformation_料理ジャンル-その他'},
        ],
        position: [
            {positionName: POSITION_KITCHEN_STAFF, dataClickLabel: 'CT_Jobinformation_職種-キッチンスタッフ'},
            {positionName: FILTER_POSITION_SERVICE_STAFF, dataClickLabel: 'CT_Jobinformation_職種-サービススタッフ'},
            {positionName: FILTER_POSITION_HEAD_CHEF, dataClickLabel: 'CT_Jobinformation_職種-料理長'},
            {positionName: FILTER_POSITION_MANAGER, dataClickLabel: 'CT_Jobinformation_職種-店長'},
            {positionName: POSITION_PATISSIER, dataClickLabel: 'CT_Jobinformation_職種-パティシエ'},
            {positionName: FILTER_POSITION_BOULANGER, dataClickLabel: 'CT_Jobinformation_職種-ブーランジェ'},
            {positionName: POSITION_SUPERVISOR, dataClickLabel: 'CT_Jobinformation_職種-スーパーバイザー'}
        ],
    },

    parameterMapping: {
        area: {
            '名古屋市': { cityId: 1052 },
            '名古屋市外': { cityId: 1068 },
            '岐阜県': { cityId: 967 },
            '三重県': { cityId: 1138 },
        },
        genre: {
            [GENRE_ITALIAN]: { genreId: 1 },
            [GENRE_FRENCH]: { genreId: 2 },
            [GENRE_IZAKAYA]: { genreId: 11 },
            [GENRE_CAFE]: { genreId: 20 },
            [GENRE_JAPANESE]: { genreId: 5 },
            [GENRE_WESTERN]: { genreId: 4 },
            [GENRE_BAKERY]: { genreId: 22 },
            [GENRE_SUSHI]: { genreId: 7 },
            [GENRE_CHINESE]: { genreId: 17 },
            [GENRE_HOTEL]: { genreId: 23 },
            [GENRE_BRIDAL]: { genreId: 25 },
            [GENRE_MASS_CATERING]: { genreId: 24 },
            [GENRE_OTHER]: { genreId: 31 },
        },
        position: {
            [POSITION_KITCHEN_STAFF]: { occupationId: 4 },
            [FILTER_POSITION_SERVICE_STAFF]: { occupationId: 3 },
            [FILTER_POSITION_HEAD_CHEF]: { occupationId: 2 },
            [FILTER_POSITION_MANAGER]: { occupationId: 1 },
            [POSITION_PATISSIER]: { occupationId: 11 },
            [FILTER_POSITION_BOULANGER]: { occupationId: 12 },
            [POSITION_SUPERVISOR]: { occupationId: 19 }
        }
    },

    jobInformationData: {
        dataClickLabels: {
            area: 'CT_Jobinformation_エリア',
            genre: 'CT_Jobinformation_料理ジャンル',
            position: 'CT_Jobinformation_職種',
        }
    }
}
